import {currencies} from "../currency/model/currencies.model";

export const sum = (prices, ignoreMissing = true) => {

    let sum = null;

    for (let price of prices) {

        if (!price) {
            if (ignoreMissing) {
                continue;
            } else {
                return null;
            }
        }

        if (sum && price.currency != sum.currency) {
            return null;
        }

        sum = sum ? {
            amount: sum.amount + price.amount,
            currency: price.currency
        } : price;

    }

    return sum;
}

export const fromRawAmount = (rawAmount, currency) => {
    const digits = (currencies[currency] ?? null)?.decimal_digits ?? 2;
    const divisor = 10**digits;

    return {
        amount: Number.isFinite(rawAmount) ? rawAmount/divisor : 0,
        currency: currency,
    }
}
